import { createFileRoute } from '@tanstack/react-router';

import { VerifyEmailForm } from '@/features/auth/view/email-verify-form/VerifyEmailForm';

export const Route = createFileRoute('/_auth/auth/forgot-password_/email')({
  component: VerifyEmailForm
});
